<li *ngFor="let item of data">
    <h5 class="name">{{ item.userName | email }}</h5>
    <span class="time">{{item.date | dateTimeFormat}}</span>
    <p>hat <a>{{item.price.amount | currency: item.price.currency}}</a> für <a>{{item.name}}</a> gespendet.</p>
</li>
